<div class="container-fluid wrapper-page" id="doctorarea">
  <!-- <div align="center" class="page-head">
    <h4 class="mt-2 mb-2">DOCTOR AREA > PATIENT BOARD</h4>
  </div> -->
  <div>
    <h5>
      <a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK </i></a>
    </h5>
  </div>
  <!--<div *ngIf="isPhyCheckOutLoading">
    <appLoader [size]="small" [display]="isPhyCheckOutLoading" [screen]="container" style="z-index: 1000">
    </appLoader>
  </div>-->
  <!--<form #phydashForm="ngForm" enctype="multipart/form-data">-->
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <ul role="tablist">
            <li role="tab">
              <a class="nav-link" (click)="phydashAssignTab('personalInformation')" [ngClass]="{
                  active: phydashCurrentTab == 'personalInformation'
                }" href="javascript:void(0)" role="tab"><span class="number">1.</span>Personal Information</a>
            </li>
            <li role="tab">
              <a href="javascript:void(0)" (click)="phydashAssignTab('bankAccount')"
                [ngClass]="{ active: phydashCurrentTab == 'bankAccount' }" class="nav-link"><span
                  class="number">2.</span>Bank Account</a>
            </li>
            <li role="tab">
              <a href="javascript:void(0)" (click)="
                  phydashAssignTab('appointment'); getUpcomingAppointment()
                " [ngClass]="{ active: phydashCurrentTab == 'appointment' }" aria-controls="steps-uid-0-p-2"
                class="nav-link">
                <span class="number">3.</span>Appointment</a>
            </li>





            <li role="tab">
              <a href="javascript:void(0)" (click)="
                  phydashAssignTab('files_list');
                " [ngClass]="{ active: phydashCurrentTab == 'files_list' }" aria-controls="steps-uid-0-p-2"
                class="nav-link">
                <span class="number">4.</span>My Files</a>
            </li>



          </ul>
          <!-- ===============Personal INFORMATION========================== -->
          <ng-container *ngIf="phydashCurrentTab == 'personalInformation'">
            <section class="mt-3 ml-2 align-items-center">
              <div class="row">
                <div class="col-md-12">
                  <div class="card m-b-30 fix">
                    <div class="card-body">
                      <div class="row">
                        <!-- <div class="col-md-6">
                            <h6 class="heading_color">Personal DETAILS</h6>
                          </div> -->
                      </div>
                      <div class="row" *ngIf="physician">
                        <div class="col-md-12 custom_column">
                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold">Physician Name :</label>
                            </div>
                            <div class="col-12 pl-0 pr-0">
                              <p class="font-weight-100 ml-5">
                                {{ physician?.first_name }}
                                {{ physician?.last_name }}
                              </p>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold">Qualification :
                              </label>
                            </div>
                            <div class="col-12 pl-0 pr-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                phyQualification
                                ? phyQualification
                                : "Not Available"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold">Specialization :
                              </label>
                            </div>
                            <div class="col-12 pl-0 pr-0 col-md-6">
                              <p class="text-break font-weight-100 ml-5">
                                {{
                                getPhysicianSpecialities(
                                physician.physician_speciality
                                )
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold">Consultation Fee :
                              </label>
                            </div>
                            <div class="col-12 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                physician.consult_fee
                                ? physician.consult_fee
                                : "Not Available"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold">Followup Fee :
                              </label>
                            </div>
                            <div class="col-12 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                physician.physician_consultfee
                                ? physician?.physician_consultfee[0]
                                .followup_fee
                                : "Not
                                Available"
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold">Email Id :
                              </label>
                            </div>
                            <div class="col-12 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                physician.email_id
                                ? physician.email_id
                                : "Not Available"
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="d-flex">
                            <div class="col-5 pl-0 pr-0">
                              <label class="f-s-13 m-l-20 font-weight-bold">Contact Number :
                              </label>
                            </div>
                            <div class="col-12 pl-0">
                              <p class="font-weight-100 ml-5">
                                {{
                                physician.contact_no
                                ? physician.contact_no
                                : "Not Available"
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>

          <!----======== BANK ACCOUNT=========================  -->
          <form #editDoctorFormSuperadmin="ngForm" [formGroup]="formsSuperadmin['bankAccount']">
            <ng-container *ngIf="phydashCurrentTab == 'bankAccount'">
              <section class="mt-3 ml-2 align-items-center">
                <div class="d-flex">
                  <div class="pl-0 pr-0">
                    <label class="font-weight-bold">Physician Name :</label>
                  </div>
                  &nbsp;&nbsp;
                  <div class="pl-0 pr-0">
                    <p class="font-weight-100">
                      {{ physician?.first_name }}
                      {{ physician?.last_name }}
                    </p>
                  </div>
                </div>
                <br />

                <div class="form-group row mb30">
                  <!--Beneficiary Name-->
                  <label class="col-lg-2 col-form-label">Beneficiary Name</label>
                  <div class="col-lg-4">
                    <input type="text" class="form-control" formControlName="beneficiary_name" required />
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('beneficiary_name')
                          .hasError('required')
                      " class="invalid-feedback">
                      Beneficiary Name is <strong>required</strong>.
                    </div>
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('beneficiary_name')
                          .hasError('pattern')
                      " class="invalid-feedback">
                      Beneficiary Name is <strong>invalid</strong>.
                    </div>
                  </div>

                  <!--Account Number-->
                  <label class="col-lg-2 col-form-label">Account Number</label>
                  <div class="col-lg-4">
                    <input type="text" class="form-control" formControlName="account_number" required />
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('account_number')
                          .hasError('required')
                      " class="invalid-feedback">
                      Account Number is <strong>required</strong>.
                    </div>
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('account_number')
                          .hasError('pattern')
                      " class="invalid-feedback">
                      Account Number is <strong>invalid</strong>.
                    </div>
                  </div>

                  <!--Confirm Account Number-->
                  <label class="col-lg-2 col-form-label" *ngIf="enableEdit">Confirm Account Number</label>
                  <div class="col-lg-4" *ngIf="enableEdit">
                    <input type="text" class="form-control" formControlName="confirm_account_number" required />
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('confirm_account_number')
                          .hasError('required')
                      " class="invalid-feedback">
                      Confirm Account Number is <strong>required</strong>.
                    </div>
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('confirm_account_number')
                          .hasError('pattern')
                      " class="invalid-feedback">
                      Confirm Account Number <strong>is invalid</strong>.
                    </div>
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('confirm_account_number')
                          .hasError('confirmedValidator')
                      " class="invalid-feedback">
                      Account number and Confirm Account Number
                      <strong>do not match</strong>.
                    </div>
                  </div>

                  <!--IFSC Code-->
                  <label class="col-lg-2 col-form-label">IFSC Code</label>
                  <div class="col-lg-4">
                    <input type="text" class="form-control" formControlName="ifsc_code" required />
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('ifsc_code')
                          .hasError('required')
                      " class="invalid-feedback">
                      IFSC Code is <strong>required</strong>.
                    </div>
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('ifsc_code')
                          .hasError('pattern')
                      " class="invalid-feedback">
                      IFSC Code is <strong>invalid</strong>.
                    </div>
                  </div>

                  <!--Account Type-->
                  <label class="col-lg-2 col-form-label">Account Type</label>
                  <div class="col-lg-4">
                    <select class="selectpicker form-control" formControlName="account_type">
                      <option *ngFor="let accType of phyBankAccType" [ngValue]="accType">
                        {{ accType }}
                      </option>
                    </select>
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('account_type')
                          .hasError('required')
                      " class="invalid-feedback">
                      Account Type is <strong>required</strong>.
                    </div>
                    <div *ngIf="
                        formsSuperadmin['bankAccount']
                          .get('account_type')
                          .hasError('pattern')
                      " class="invalid-feedback">
                      Account Type is <strong>invalid</strong>.
                    </div>
                  </div>
                </div>

                <!--Terms and Conditions-->
                <div class="form-group row mb30">
                  <div class="col-lg-12">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="terms" [(ngModel)]="termsConditions"
                        [ngModelOptions]="{ standalone: true }" [disabled]="!enableEdit" />
                      <label class="form-check-label" for="terms">I accept terms and conditions.
                        <span class="invalid-feedback" *ngIf="!termsConditions">* required</span>
                      </label>
                    </div>
                  </div>
                </div>
                <br />

                <!--Enable Edit-->
                <button type="button" class="btn btn-primary mr-5 mr-md-4 pull-right" id="edit"
                  *ngIf="formsSuperadmin['bankAccount'].disabled" [disabled]="formsSuperadmin['bankAccount'].enabled"
                  (click)="enableForm()">
                  Edit
                </button>

                <!--Save-->
                <button type="button" class="btn btn-primary mr-5 mr-md-4 pull-right"
                  *ngIf="formsSuperadmin['bankAccount'].enabled" id="update" [disabled]="
                    formsSuperadmin['bankAccount'].invalid ||
                    !termsConditions ||
                    formsSuperadmin['bankAccount'].disabled
                  " (click)="saveBankDetails()">
                  Save
                </button>
              </section>
            </ng-container>
          </form>

          <!----======== APPOINTMENT=========================  -->
          <ng-container *ngIf="phydashCurrentTab == 'appointment'">
            <section class="mt-3 ml-2 align-items-center">
              <div class="row">
                <div class="d-flex ml-3 align-middle">
                  <button type="button" (click)="upcoming = true; getUpcomingAppointment()"
                    class="btn btn-lg h-50 btn-primary mt-3" style="font-size: 14px" id="upcoming" [ngClass]="{
                      'btn-primary': appointmentType === 'upcoming'
                    }">
                    Upcoming Appointment
                  </button>
                  <button type="button" (click)="upcoming = false; getPastAppointment()"
                    class="btn btn-lg h-50 btn-primary mt-3" style="margin-left: 15px; font-size: 14px" id="completed"
                    [ngClass]="{ 'btn-primary': appointmentType === 'past' }">
                    Completed Appointment
                  </button>
                  <button type="button" (click)="upcoming = false; getAllAppointment()"
                    class="btn btn-lg h-50 btn-primary mt-3" style="margin-left: 15px; font-size: 14px" id="all"
                    [ngClass]="{ 'btn-primary': appointmentType === 'all' }">
                    All Appointment
                  </button>
                </div>
                <div class="col-md-5"></div>
                <div class="d-flex" *ngIf="
                    pastAppointmentData?.result ||
                    upcomingAppointmentData?.result ||
                    allAppointmentData?.result
                  ">
                  <div class="pl-0 pr-0 align-items-center pull-right mt-3 ml-5">
                    <p class="font-weight-100">
                      <button (click)="exportAsXLSX()">
                        <i class="fa fa-file-excel-o mr-1" style="font-size: 23px; color: blue"></i>
                      </button>
                    </p>
                  </div>
                  <div class="pl-0 pr-0 ml-2 pull-right mt-4">
                    <label class="font-weight-bold">Click Icon to Download</label>
                  </div>
                </div>
              </div>

              <br />
              <br />

              <div class="d-flex">
                <div class="pl-0 pr-0">
                  <label class="font-weight-bold">Physician Name :</label>
                </div>
                &nbsp;&nbsp;
                <div class="pl-0 pr-0">
                  <p class="font-weight-100">
                    {{ physician?.first_name }}
                    {{ physician?.last_name }}
                  </p>
                </div>
              </div>
              <br />

              <table class="table" *ngIf="appointmentType === 'upcoming'">
                <thead>
                  <tr>
                    <th scope="col">APT ID</th>
                    <th scope="col">APT DATE</th>
                    <th scope="col">APT TIME</th>
                    <th scope="col">PATIENT NAME</th>
                    <th scope="col">APT TYPE</th>
                    <th scope="col">STATUS</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let data of upcomingAppointmentData?.result">
                    <td scope="row">
                      {{ data.aptid === null ? "Not Available" : data.aptid }}
                    </td>
                    <td>
                      {{
                      data.apdate === null
                      ? "Not Available"
                      : (data.apdate | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td>
                      {{ data.aptime === null ? "Not Available" : data.aptime }}
                    </td>
                    <td>
                      {{
                      data.first_name === null && data.last_name === null
                      ? "Not
                      Available"
                      : data.first_name + " " + data.last_name
                      }}
                    </td>
                    <td>
                      {{
                      data.apttype === null
                      ? "Not Available"
                      : data.apttype.replace("_", " ").toUpperCase()
                      }}
                    </td>
                    <td>
                      {{
                      data.schedule_stat === null
                      ? "Not
                      Available"
                      : data.schedule_stat.replace("_", " ").toUpperCase()
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table" *ngIf="appointmentType === 'past'">
                <thead>
                  <tr>
                    <th scope="col">APT ID</th>
                    <th scope="col">APT DATE</th>
                    <th scope="col">APT TIME</th>
                    <th scope="col">PATIENT NAME</th>
                    <th scope="col">APT TYPE</th>
                    <th scope="col">STATUS</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let data of pastAppointmentData?.result">
                    <td scope="row">
                      {{ data.aptid === null ? "Not Available" : data.aptid }}
                    </td>
                    <td>
                      {{
                      data.apdate === null
                      ? "Not Available"
                      : (data.apdate | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td>
                      {{ data.aptime === null ? "Not Available" : data.aptime }}
                    </td>
                    <td>
                      {{
                      data.first_name === null && data.last_name === null
                      ? "Not
                      Available"
                      : data.first_name + " " + data.last_name
                      }}
                    </td>
                    <td>
                      {{
                      data.apttype === null
                      ? "Not Available"
                      : data.apttype.replace("_", " ").toUpperCase()
                      }}
                    </td>
                    <td>
                      {{
                      data.schedule_stat === null
                      ? "Not
                      Available"
                      : data.schedule_stat.replace("_", " ").toUpperCase()
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table" *ngIf="appointmentType === 'all'">
                <thead>
                  <tr>
                    <th scope="col">APT ID</th>
                    <th scope="col">APT DATE</th>
                    <th scope="col">APT TIME</th>
                    <th scope="col">PATIENT NAME</th>
                    <th scope="col">APT TYPE</th>
                    <th scope="col">STATUS</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let data of allAppointmentData?.result">
                    <td scope="row">
                      {{ data.aptid === null ? "Not Available" : data.aptid }}
                    </td>
                    <td>
                      {{
                      data.apdate === null
                      ? "Not Available"
                      : (data.apdate | date: "dd-MMM-yyyy")
                      }}
                    </td>
                    <td>
                      {{ data.aptime === null ? "Not Available" : data.aptime }}
                    </td>
                    <td>
                      {{
                      data.first_name === null && data.last_name === null
                      ? "Not
                      Available"
                      : data.first_name + " " + data.last_name
                      }}
                    </td>
                    <td>
                      {{
                      data.apttype === null
                      ? "Not Available"
                      : data.apttype.replace("_", " ").toUpperCase()
                      }}
                    </td>
                    <td>
                      {{
                      data.schedule_stat === null
                      ? "Not
                      Available"
                      : data.schedule_stat.replace("_", " ").toUpperCase()
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <br />
              <br />

              <br />
            </section>
          </ng-container>

          <!-- Doctor Files View and Download UI -->

          <ng-container *ngIf="phydashCurrentTab == 'files_list'">
            <section class="mt-3 ml-2 align-items-center">

              <div class="row">
                <div class="col-md-12">
                  <div class="card m-b-30 fix">
                    <div class="card-body">
                      <div class="row">
                      </div>
                      <div class="row">
                        <div class="col-md-12 pr-2 detail-tbl">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">Description</th>
                                  <th scope="col">Name</th>
                                  <th scope="col">View</th>
                                  <th scope="col">Download</th>
                                </tr>
                              </thead>
                              <tr *ngFor="let doc of appointment">
                                <td class="text-capitalize">{{ doc?.description }}</td>
                                <td>{{ doc?.name }}</td>
                                <td>
                                  <a class="cursor" (click)="previewDocument(doc)">View</a>
                                </td>
                                <td>
                                  <a class="cursor" (click)="downloadDocument(doc)">Download</a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- PDF popup UI -->
<ng-template #PDFModal>
  <div>
    <div class="modal-header">
      <button type="button" class="close" (click)=closeModal()>&times;</button>
    </div>
    <div>
      <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
    </div>
  </div>
</ng-template>